/**
 * Diretiva responsável por apresentar um endereço eletrônico com prefixo, se apropriado.
 */

angular.module("avlib").directive("avEAddressDisplay", function(){
	return {
		template: require("!html-loader!./EAddressDisplayTemplate.html"),
		restrict: "E",
		scope: {
			eAddresses: '=',
		},
	};
});
